import { CardsData } from "./CardsData";
import { memoParseISO } from "../utils/dateUtils";

export function IsSelectable(option: CardsData, giorno: Date, certObbl: boolean): boolean {
  let disattivata = option.disattivata !== 0;

  if (!disattivata) {
    if (certObbl && option.certificato !== 1) disattivata = true;

    if (option.dtBlocco !== null && memoParseISO(option.dtBlocco.slice(0, -1)) <= giorno) {
      disattivata = true;
    }

    if (option.dtScadenza !== null && memoParseISO(option.dtScadenza.slice(0, -1)) <= giorno) {
      disattivata = true;
    }
  }

  return !disattivata;
}
